import styled from "styled-components";

export const HeaderFilterWrapper = styled.div`
  position: sticky;
  flex-direction: column;
  top: 0;
  left: 0;
  height: auto;
  width: 100vw;
  max-width: 100vw;
  min-width: 100vw;
  margin-left: calc(-50vw + 50%);
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 1000;
  display: flex;
  padding: 10px 10px;
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.2);
  justify-content: center;
  align-items: center;
`;

export const OrderFilterWrapper = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(1)};

  & > div {
    width: 100%;
  }
`;

export const ButtonsFilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  flex-wrap: nowrap; /* NÃO deixa quebrar */

  /* Esconde a scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  /* Garante que cada filho não sofra shrink */
  & > * {
    flex-shrink: 0;
  }
`;
